<template>
  <a-modal :closable="false" :width="230" v-model="loading" :footer="null" :centered="true">
    <a-progress :percent="percent" :status="status" :width="180" type="circle">
      <template #format="percent">
        <template v-if="percent<100">{{ percent }}%</template>
        <a-spin v-if="loading && percent===100" :spinning="true" tip="打包中"/>
      </template>
    </a-progress>
  </a-modal>
</template>

<script>
import api from "../../../../../utils/api";
import func from "../../../../../utils/func";
import dload from "../../../../../utils/dload";
import enums from "../../../../../utils/enums";
import DelayLoading from "../../../../../comps/DelayLoading";

export default {
  name: "DownloadPg",
  mixins: [DelayLoading],
  props: {
    album: Object,
    loadFunc: Function,
  },
  data() {
    return {
      percent: 0,
      status: "normal"
    }
  },
  methods: {
    start(photos) {
      const self = this;
      this.percent = 0;
      let args = {
        ids: photos.join(","),
        page_size: photos.length,
      };
      this.loadFunc(this.album.id, args)
          .then((res) => {
            if (res.total === 0) {
              return self.$message.error(`不存在下载数据`);
            }
            self.withLoading(300, async () => {
              let files = [];
              let urls = await api.v1.album.photo.URL(this.album.id, photos);
              res.data.forEach(item => {
                if (!func.isDefined(urls[item.id])) return;
                if (item.raw.id !== "") {
                  let name = `${enums.Upload.TypeRaw}#${item["info"]["catch_time"]}#${item["info"]["file_name"]}`;
                  files.push({url: urls[item.id], name: name});
                }
                if (item["foto"]["id"] !== "") {
                  let type = item.origin ? enums.Upload.TypeOrigin : enums.Upload.TypeHD;
                  let name = `${type}#${item["info"]["catch_time"]}#${item["info"]["file_name"]}`;
                  files.push({url: urls[item.id], name: name});
                }
              });
              return new Promise(function (resolve, reject) {
                let date = func.dateFormat(new Date(), "YYYYMMDDHHmmss");
                let name = self.album.name ? self.album.name : self.album.info.name;
                dload.download(`${name}_${date}`, files, (done, total) => {
                  self.percent = parseInt((done * 100 / total).toFixed(2));
                }).then(resolve).catch(reject);
              });
            });
          });
    },
  }
}
</script>
